import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LearnerProfileHierarchyWidgetQueryVariables = Types.Exact<{
  learnerId: Types.Scalars['String']['input'];
}>;


export type LearnerProfileHierarchyWidgetQuery = { user?: { id: string, manager?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, reportees?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null } | null };

export type LearnerProfileHierarchyWidgetFragment = { id: string, manager?: { id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null, reportees?: Array<{ id: string, name?: string | null, firstName?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null }> | null };


export type LearnerProfileHierarchyWidgetFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const LearnerProfileHierarchyWidgetFragmentDoc = /*#__PURE__*/ gql`
    fragment LearnerProfileHierarchyWidget on UserType {
  id
  manager {
    ...User
  }
  reportees {
    ...User
  }
}
    `;
export const LearnerProfileHierarchyWidgetDocument = /*#__PURE__*/ gql`
    query learnerProfileHierarchyWidget($learnerId: String!) {
  user(filters: {userId: $learnerId}) {
    ...LearnerProfileHierarchyWidget
  }
}
    ${LearnerProfileHierarchyWidgetFragmentDoc}
${UserFragmentDoc}`;

export function useLearnerProfileHierarchyWidgetQuery(options: Omit<Urql.UseQueryArgs<LearnerProfileHierarchyWidgetQueryVariables>, 'query'>) {
  return Urql.useQuery<LearnerProfileHierarchyWidgetQuery, LearnerProfileHierarchyWidgetQueryVariables>({ query: LearnerProfileHierarchyWidgetDocument, ...options });
};